import { Step } from "../../../types/Step";
import AllMedicalQuestionsEvaluator from "../../Steps/Medical/Compositions/AllMedicalQuestionsEvaluator";
import { FlowStepsConfiguration } from "../../Types/IFlow";
import NavigatorItemId from "../Types/NavigatorItemId";

/** The configured steps for screening qualified customers including qualify and medical steps. */
export const screeningStepConfigurations: FlowStepsConfiguration = {
  [Step.qualify]: {
    activeNavigatorItem: NavigatorItemId.Screening,
    key: Step.qualify,
    nextStep: ({ customerCState: { height, weight, dateOfBirth }, disqualifyingReasonsCState }) =>
      height && weight && dateOfBirth && disqualifyingReasonsCState ? Step.medicalCombined : undefined
  },
  [Step.medicalCombined]: {
    activeNavigatorItem: NavigatorItemId.Screening,
    key: Step.medicalCombined,
    nextStep: ({ medicalForm, disqualifyingReasonsCState }) => {
      if (disqualifyingReasonsCState && AllMedicalQuestionsEvaluator.isComplete(medicalForm)) return Step.scheduling;
      return undefined;
    }
  }
};

/** The configured scheduling steps that support changing the center, with no confirmation step (books directly). */
export const noConfirmationCenterSelectableBookingStepConfigurations: FlowStepsConfiguration = {
  [Step.scheduling]: {
    activeNavigatorItem: NavigatorItemId.Scheduling,
    key: Step.scheduling,
    nextStep: null
  },
  [Step.centerSelection]: {
    activeNavigatorItem: NavigatorItemId.Scheduling,
    key: Step.centerSelection,
    nextStep: () => Step.scheduling
  }
};

/** The configured scheduling steps that do not allow for the center to be changed, with no confirmation step (books directly). */
export const noConfirmationStaticCenterBookingStepConfigurations: FlowStepsConfiguration = {
  [Step.scheduling]: noConfirmationCenterSelectableBookingStepConfigurations[Step.scheduling]
};
